'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeConsumer = exports.ThemeProvider = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _defaultTheme = require('./default-theme/');

var _defaultTheme2 = _interopRequireDefault(_defaultTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Use React 16.3+ createContext API.
 */
var _React$createContext = _react2.default.createContext(_defaultTheme2.default),
    ThemeProvider = _React$createContext.Provider,
    ThemeConsumer = _React$createContext.Consumer;

exports.ThemeProvider = ThemeProvider;
exports.ThemeConsumer = ThemeConsumer;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90aGVtZS9zcmMvVGhlbWVDb250ZXh0LmpzIl0sIm5hbWVzIjpbIlJlYWN0IiwiY3JlYXRlQ29udGV4dCIsImRlZmF1bHRUaGVtZSIsIlRoZW1lUHJvdmlkZXIiLCJQcm92aWRlciIsIlRoZW1lQ29uc3VtZXIiLCJDb25zdW1lciJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7OztBQUVBOzs7MkJBTUlBLGdCQUFNQyxhQUFOLENBQW9CQyxzQkFBcEIsQztJQUZRQyxhLHdCQUFWQyxRO0lBQ1VDLGEsd0JBQVZDLFE7O1FBR09ILGEsR0FBQUEsYTtRQUFlRSxhLEdBQUFBLGEiLCJmaWxlIjoiVGhlbWVDb250ZXh0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IGRlZmF1bHRUaGVtZSBmcm9tICcuL2RlZmF1bHQtdGhlbWUvJ1xuXG4vKipcbiAqIFVzZSBSZWFjdCAxNi4zKyBjcmVhdGVDb250ZXh0IEFQSS5cbiAqL1xuY29uc3Qge1xuICBQcm92aWRlcjogVGhlbWVQcm92aWRlcixcbiAgQ29uc3VtZXI6IFRoZW1lQ29uc3VtZXJcbn0gPSBSZWFjdC5jcmVhdGVDb250ZXh0KGRlZmF1bHRUaGVtZSlcblxuZXhwb3J0IHsgVGhlbWVQcm92aWRlciwgVGhlbWVDb25zdW1lciB9XG4iXX0=